import { HttpClient } from '@angular/common/http';
import { Component, ComponentFactoryResolver, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { alert, confirm } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from '../../../environments/environment';
import { NewNicaFormComponent } from '../../components/nica-form/new-nica-form.component';
import { NicaMaster } from '../../components/nica-master-component/nica-master.component';
import { OverlaySideFormService } from '../../components/shared/overlay-side-form/overlay-side-form.service';
import { VivifirComponent } from '../../components/vivifir/vivifir.component';
import { AnagraficaService } from '../../services/anagrafica.service';
import { Apiservice } from '../../services/api.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService } from '../../services/forms-template.service';
import { NicaMenuService } from '../../services/nica-menu.service';
import { RentriService } from '../../services/rentri.service';
import { UtilityService } from '../../services/utility.service';
import { VivifirService } from '../../services/vivifir.service';

export interface GetBlocchiVirtuali {
  versione: number;
  idSoggetto: number;
  codiceFiscale: string;
  codiceBlocco: string;
  descrizione: string;
  descrzioneFull: string;
  isSpurghi: boolean;
  disattivato: boolean;
  dataCreazione: string;
  dataUltimoUtilizzo: string;
}
export interface FormDataMap {
  rentri: FormData;
  dh: { [key: string]: any };
  vivifir: { [key: string]: any };
}
export interface PostBlocchiVirtuali {
  id: number
  codiceFiscale: string
  idSoggetto: number
  blocco: string
  descrizione: string
  listaPosizioni: []
  elencoPosizioni: []
  isSpurghi: boolean
  isAnnullato: boolean
  numeroFirLiberi: number
  versione: number
}

@Component({
  selector: 'app-configurazioni-moduli',
  templateUrl: './configurazioni-moduli.component.html',
  styleUrls: ['./configurazioni-moduli.component.css']
})

export class ConfigurazioniModuliComponent extends NicaMaster implements OnInit {
  @ViewChild('formAnagrafica', { static: false }) formAnagrafica: NewNicaFormComponent;
  @ViewChild('vivifir', { static: false }) vivifir: VivifirComponent;

  service = 'NewConfigurazioniModuli'
  CustomButtonForm = []
  showForm: boolean = false;
  soggettoObgj = null
  moduliValue: { [key: string]: any }[] = []
  isNewConfiguration = false
  isConfigStart: boolean = false;
  idAzienda: number;

  listaBlocchi: GetBlocchiVirtuali[] = [];
  codiceFiscale: string;
  codiceBlocco: string;
  idSoggetto: number;
  idBlocco: number
  isRentri: boolean = true;
  isSpurghi: boolean;
  isAnnullato: boolean;
  showBlocchi: boolean = false;
  elencoBlocchiViviFir: any;
  firLiberi: number;
  maxFir: number
  showInfoFir: boolean = false
  startSync: boolean = false


  constructor(
    public userComponentService: ComponentService,
    public templateService: FormsTemplateService,
    public _overlaySideFormService: OverlaySideFormService,
    public _overlaySidePanelService: OverlaySideFormService,
    public formTemplateService: FormsTemplateService,
    public _componentFactoryResolver: ComponentFactoryResolver,
    public activatedroute: ActivatedRoute,
    public router: Router,
    public menuService: NicaMenuService,
    public rentriService: RentriService,
    public anagraficaService: AnagraficaService,
    private viviFirService: VivifirService,
    private httpClient: HttpClient,
    private apiService: Apiservice,
    private spinner: NgxSpinnerService,
    private utility: UtilityService,

  ) {
    super(
      userComponentService,
      templateService,
      _overlaySideFormService,
      _overlaySidePanelService,
      formTemplateService,
      _componentFactoryResolver,
      activatedroute,
      router,
      menuService,
      rentriService,
      anagraficaService

    );


  }
  async ngOnInit(): Promise<void> {
    this.activatedroute.queryParams.subscribe(params => {
      this.itemData = params,
        this.currentTabId = params.currentTabId,
        this.currentTabName = params.currentTabName,

        this.setGlobalVariableFromParams(params)
      if (params.service === 'Configurazioni') {
        this.service = params.service; this.apiset = 'ConfigurazioniModuli'

        this.CustomButtonForm.push({
          widget: 'dxButton',
          stylingMode: 'contain',
          text: 'Salva',
          icon: 'icon-salva-form',
          hint: 'Salva configurazioni',
          visible: true,
          disabled: false,
          id: 'salvaConfigurazioni'
        })
      }
      this.loadConfiguration()

    });
    if (this.filterID['idSoggetto']) {
      if (this.filterID['nomeModulo'] === 'VIVIFIR') await this.getElencoBlocchiVirtuali(this.filterID['idSoggetto'])
      this.apiService.GetApi(`soggetto/${this.filterID['idSoggetto']}`).then((res) => {
        this.soggettoObgj = res
      }).catch(() => {
        return
      })
    }

  }

  selectionChanged(event) {
    this.spinner.show()
    if (event.selectedItem == null) {
      this.isAnnullato = false
      this.showBlocchi = false
      this.showInfoFir = false
      this.spinner.hide()
      return
    }
    const value: GetBlocchiVirtuali = event.selectedItem;
    this.showBlocchi = false
    this.showInfoFir = false
    // console.log('selectionChanged', event)

    let instanceData = {
      codiceFiscale: value.codiceFiscale,
      idSoggetto: value.idSoggetto,
      blocco: value.codiceBlocco,
      descrizione: value.descrizione,
      isSpurghi: value.isSpurghi,
      isAnnullato: value.disattivato,
    }
    this.apiService.PostApi(`VivifirBlocchi`, instanceData).then((res: any) => {
      if (res.codeMessage == 0) {
        this.codiceFiscale = value.codiceFiscale
        this.idSoggetto = value.idSoggetto
        this.isSpurghi = value.isSpurghi
        this.idBlocco = res.result
        this.codiceBlocco = value.codiceBlocco
        this.isAnnullato = value.disattivato
        this.showBlocchi = true
      } else {
        this.codiceFiscale = res.codiceFiscale
        this.idSoggetto = value.idSoggetto
        this.isSpurghi = res.isSpurghi
        this.idBlocco = res.id
        this.isAnnullato = res.isAnnullato
        this.codiceBlocco = res.blocco
        this.showBlocchi = true
      }
      this.spinner.hide()
    }).catch(() => {
      this.spinner.hide()
      return alert('Errore durante la selezione del blocco', 'Attenzione!')
    })
  }

  async getElencoBlocchiVirtuali(idSoggetto: number) {
    await this.apiService.GetApi(`VivifirBlocchi/GetElencoBlocchiVirtuali?idSoggetto=${idSoggetto}`).then((res: any) => {
      if (res.items.length == 0) return alert(res.descrMessage, 'Attenzione!')
      this.listaBlocchi = res.items
    }).catch(() => {
      return
    })
  }

  async loadConfiguration() {
    if (this.filterID['nomeModulo'] === 'VIVIFIR') {
      this.helpDoc = 'ConfigurazioniModuloViViFir.html'

      //this.isViviFirComponent = true;
    }

    let res: any = await this.anagraficaService.getValue('ConfigurazioniModuli', '', this.queryString)

    if (this.filterID['nomeModulo'] === 'Configurazioni' && this.filterID['idSoggetto']) {
      this.moduliValue = res['items']
    }

    if (Object.keys(res).length == 0) {
      this.isNewConfiguration = true;
      this.isConfigStart = true
      res['modulo'] = this.filterID['nomeModulo']
      res['idSoggetto'] = this.filterID['idSoggetto']
    }
    if (this.filterID['nomeModulo'] !== 'Configurazioni') {
      // res['listaBlocchi'] = await this.getVivifirBlocchi(res['idSoggetto'])
    }

    res['soggetto'] = this.filterID['idSoggetto'];
    this.filterID['nomeModulo'] !== 'Configurazioni' ? this.rowData = res : null


    this.showForm = true;


  }

  async getVivifirBlocchi(idSoggetto) {

    const isSpurghi = this.filterID['nomeModulo'] == 'VIVIFIR' ? true : false

    let queryS = `?idSoggetto=${idSoggetto}&$filter=(isSpurghi eq ${isSpurghi})`

    let vvfir: any = await this.anagraficaService.getElenco('VivifirBlocchi', '', queryS)

    if (vvfir['items'].length > 0) {
      return vvfir['items']
    }

    return [];
  }
  formEventInitializzedModuli(ev) {
    switch (this.filterID['nomeModulo']) {
      case 'Configurazioni':
        if (this.moduliValue) {
          console.log(this.formAnagrafica.dataSet)
          console.log(this.moduliValue)
          this.moduliValue.forEach(element => {
            const modulo = element.modulo.toLowerCase()
            Object.keys(this.formAnagrafica.dataSet).forEach((key: string) => {
              if (key.includes(modulo)) {
                this.formAnagrafica.formRefreshInputData(key, element[key.split('_')[0]])
              }
              if (!this.formAnagrafica.dataSet[key] || this.formAnagrafica.dataSet[key] === 'null') {
                this.formAnagrafica.formRefreshInputData(key, null)
              }
              if (modulo === 'rentri' && key.includes('numeroIscrizioneRentri_rentri')) this.formAnagrafica.formRefreshInputData(key, element.numeroIscrizioneRentri)
              if (modulo === 'rentri') this.formAnagrafica.dataSet['issuer'] = element.issuer
              if (modulo === 'rentri' && key.includes('certificato') && key !== 'certificatoFirmaRemota') this.formAnagrafica.formRefreshInputData(key, element.certificato)
              if (modulo === 'rentri' && key === 'certificatoFirmaRemota') this.formAnagrafica.formRefreshInputData(key, element.certificatoFirmaRemota)
              if (modulo === 'rentri' && key === 'scadenzaCertificatoFirmaRemota') this.formAnagrafica.formRefreshInputData(key, element.scadenzaCertificatoFirmaRemota)

            });
            const apiSet = []
            if (modulo === 'rentri') {
              if (element.certificato !== '') {
                apiSet.push(this.checkRentri(element))
              }
            }
            if (modulo === 'dh') {
              apiSet.push(this.checkDh(element))
            }
            if (modulo === 'vivifir') {
              apiSet.push(this.checkVivifir(element))
            }
            this.spinner.show()
            this.utility.allPromise(apiSet).then((res) => {
              const successResults = res
                .filter(r => r.status === 'completata')
                .map(r => r.value);

              const failedResults = res
                .filter(r => r.status === 'rifiutata')
                .map(r => r.error);
              return [successResults, failedResults]
            }).then(() => this.spinner.hide()).catch(() => this.spinner.hide())
          });
        }
        Object.keys(this.formAnagrafica.dataSet).forEach((key: string) => {
          if (this.formAnagrafica.dataSet[key] === null) {
            if (key === 'url_dh') this.formAnagrafica.formRefreshInputData(key, environment.END_POINT_DHWASTE)
            if (key === 'url_rentri') this.formAnagrafica.formRefreshInputData(key, environment.END_POINT_RENTRI)
            if (key === 'url_vivifir') this.formAnagrafica.formRefreshInputData(key, environment.END_POINT_VIVIFIR)
          }
          if (this.soggettoObgj && key.includes('partitaIva')) this.formAnagrafica.formRefreshInputData(key, this.soggettoObgj.partitaIVA)
          if (this.soggettoObgj && key.includes('codiceFiscale')) this.formAnagrafica.formRefreshInputData(key, this.soggettoObgj.codiceFiscale)
        })
        if (ev.formData.password_rentri === null) {
          this.formAnagrafica.itemOption('configurazione_rentri.certificato', 'disabled', true);
        } else {
          this.formAnagrafica.itemOption('configurazione_rentri.certificato', 'disabled', false);
        }
        break
    }

  }

  startSyncFir() {
    this.startSync = true
    setTimeout(() => {
      this.startSync = !this.startSync
    }, 200)
  }

  formEventModuli(e) {
    if (e.name == 'salvaConfigurazioni') {
      const validate = this.formAnagrafica.validate();
      if (!validate.isValid) {
        return
      } else {
        // this.checkRentri()
        this.saveConfiguration()
      }
    }
    if (e.name === 'removeVivifirSaved') {
      // console.log('removeVivifirSaved', e)
      this.removeConfigurazione('vivifir')
    }
    if (e.name === 'removeDhSaved') {
      // console.log('removeDhSaved', e)
      this.removeConfigurazione('dh')
    }

    return
  }

  async removeConfigurazione(type: 'vivifir' | 'dh') {
    const confirmResult = await confirm(`Sei sicuro di voler eliminare la configurazione ${type.toUpperCase()} salvata?`, 'Attenzione!');
    if (confirmResult) {
      this.spinner.show();
      const modulo = this.moduliValue.find((x) => x.modulo === type.toUpperCase()) || null
      Object.keys(this.formAnagrafica.dataSet).filter((key) => {
        if (key.includes('url') && !key.includes('vivifir')) return false
        if (key.includes('scadenza')) return false
        if (key.includes('partitaIva')) return false
        if (key.includes(type)) return true
      }).forEach((key) => {
        this.formAnagrafica.formRefreshInputData(key, null)
        switch (type) {
          case 'vivifir':
            this.formAnagrafica.formRefreshInputData('isVivifirValido', null)
            break;
          case 'dh':
            this.formAnagrafica.formRefreshInputData('firmaDH', null)
            this.formAnagrafica.formRefreshInputData('isDHAttivo', null)
            break;
          default:
            break;
        }
      })
      if (modulo !== null) {
        this.apiService.DeleteApi(`ConfigurazioniModuli/${modulo.id}`).then((res) => {
          this.spinner.hide();
          notify({
            message: `Configurazione eliminata con successo!`,
            height: 45,
            width: 250,
            position: 'center center'
          }, 'success', 4000);
        }).catch(() => {
          this.spinner.hide();
          notify({
            message: `Errore durante l'eliminazione della configurazione!`,
            height: 45,
            width: 250,
            position: 'center center'
          }, 'danger', 4000);
        })
      } else {
        this.spinner.hide();
      }

    }
  }

  async saveConfiguration() {
    this.spinner.show();
    const daEscludere = {
      dh: false,
      vivifir: false,
      rentri: false
    }
    const placeholder = {
      "id": null,
      "modulo": null,
      "idSoggetto": null,
      "user": null,
      "password": null,
      "url": null,
      "scadenza": null,
      "certificato": '',
      "certificatoFirmaRemota": '',
      "issuer": null,
      "numeroIscrizioneRentri": null,
      "company": null,
      "versione": null
    }
    const formDataMap = {
      rentri: new FormData(),
      dh: new FormData(),
      vivifir: new FormData(),
    };

    //iniziallizzzazione oggetti con parametri vuoti o standard
    Object.entries(placeholder).forEach(([key, value]) => {
      if (key === 'modulo') {
        formDataMap.rentri.set(key, 'RENTRI');
        formDataMap.dh.set(key, 'DH');
        formDataMap.vivifir.set(key, 'VIVIFIR');
      } else if (key === 'idSoggetto') {
        formDataMap.rentri.set(key, this.filterID['idSoggetto']);
        formDataMap.dh.set(key, this.filterID['idSoggetto']);
        formDataMap.vivifir.set(key, this.filterID['idSoggetto']);
      } else {
        formDataMap.rentri.set(key, value);
        formDataMap.dh.set(key, value);
        formDataMap.vivifir.set(key, value);
      }
    })
    // Assegnazione dei valori da formAnagrafica.dataSet
    Object.keys(this.formAnagrafica.dataSet).forEach((key: string) => {
      const value = this.formAnagrafica.dataSet[key];
      const keyBase = key.split('_')[0];

      if (key.includes('_rentri')) {
        formDataMap.rentri.set(keyBase, value);
      }
      if (key.includes('_dh')) {
        formDataMap.dh.set(keyBase, value);
      }
      if (key.includes('_vivifir')) {
        formDataMap.vivifir.set(keyBase, value);
      }
      if (key === 'certificato') {
        formDataMap.rentri.set(key, value);
      }
      if (key === 'certificatoFirmaRemota') {
        formDataMap.rentri.set(key, value);
      }
    });
    const validateDh: string = this.setValidation(formDataMap.dh, 'dh')
    const validateVivifir: string = this.setValidation(formDataMap.vivifir, 'vivifir')
    if (validateDh !== '' || validateVivifir !== '') {
      this.spinner.hide()
      return alert(validateDh + validateVivifir, 'Attenzione!')
    }
    this.utility.allPromise([
      this.checkDh(), this.checkVivifir(), this.checkRentri()
    ]).then((res) => {
      daEscludere['dh'] = !res[0].value;
      daEscludere['vivifir'] = !res[1].value;
      daEscludere['rentri'] = !res[2].value;
      if (!res[0].value) {
        this.spinner.hide()
        confirm(`
  <div >
    <p style="margin:3px; text-wrap: auto; max-width: 600px;">
      Non essendo stata impostata la firma qualificata DH-WASTE Zucchetti, il sistema utilizzerà temporaneamente la Firma tecnica RENTRI con le limitazioni previste dalla norma.
    </p>
    <p style="text-wrap: auto; max-width: 600px;">
      Le suggeriamo di leggere attentamente le informazioni al seguente 
      <a href="javascript:void(0)" id="firmaInfoLink">link</a> 
      e di contattare l'assistenza tecnica per i chiarimenti del caso.
    </p>
    <p style="text-align:center;">Desidera confermare l'operazione?</p>
  </div>
`, 'Attenzione').then((res) => {
          if (!res) return;
          this.sendData(daEscludere, formDataMap);

        });

        // Dopo aver mostrato la dialog, aspetta che venga renderizzata e aggancia l’evento
        setTimeout(() => {
          const link = document.getElementById('firmaInfoLink');
          if (link) {
            link.addEventListener('click', (e) => {
              e.preventDefault(); // NON cambiare pagina
              this.apriInfoFirma();
            });
          }
        }, 0);
      } else {
        this.sendData(daEscludere, formDataMap)
      }
    })

  }

  sendData(daEscludere, formDataMap) {
    this.spinner.show()
    const apiSet: Promise<any>[] = [];
    const moduliList = ['rentri', 'dh', 'vivifir']
    moduliList.forEach((modulo) => {
      const moduloDb = this.moduliValue.filter((x) => x.modulo === modulo.toUpperCase());
      const chechPresenza = this.moduliValue.map((x) => x.modulo.toLowerCase()).includes(modulo)
      const method = chechPresenza ? 'PutApi' : 'PostApi'
      const uri = 'ConfigurazioniModuli'
      if (daEscludere[modulo]) return
      if (chechPresenza) formDataMap[modulo].set('id', moduloDb[0].id)
      apiSet.push(this.apiService[method](`${uri}${chechPresenza ? `/${moduloDb[0].id}` : ''}`, formDataMap[modulo], 'multipart/form-data'));

    });
    if (apiSet.length === 0) {
      this.spinner.hide();
      return alert('Nessuna configurazione da salvare.', 'Attenzione!');
    }
    //chiamate api per ogni configurazione
    this.utility.allPromise(apiSet).then((results) => {
      const successResults = results
        .filter(r => r.status === 'completata')
        .map(r => r.value);

      const failedResults = results
        .filter(r => r.status === 'rifiutata')
        .map(r => r.error);
      return [successResults, failedResults]
    }).then(([successResults, failedResults]) => {
      this.spinner.hide();
      let msgPromise = (): string => {
        const isEsclusioni = moduliList.some((modulo) => daEscludere[modulo] === true)
        if (failedResults.length > 0) {
          return `Errore nel salvataggio delle configurazioni!`
        }
        // else if (isEsclusioni) {
        //   const moduliEsclusi = moduliList.filter((modulo) => daEscludere[modulo] === true)
        //   return `Configurazione ${moduliEsclusi.join(', ').toLocaleUpperCase()} non salvat${moduliEsclusi.length > 1 ? 'e' : 'a'}!`
        // } 
        else {
          return 'Configurazioni salvate con successo!'
        }
      }
      notify({
        message: msgPromise,
        height: 45,
        width: 250,
        position: 'center center'
      },
        // failedResults.length > 0 ? 'error' : moduliList.some((modulo) => daEscludere[modulo] === true) ? 'error' : 'success', 6000);
        failedResults.length > 0 ? 'error' : 'success', 6000);

      if (successResults && successResults.length > 0) {
        const moduliVecchi = this.moduliValue.filter((x) => !successResults.map((y) => y.modulo).includes(x.modulo))
        this.moduliValue = [...moduliVecchi, ...successResults]
      }
    });
  }
  getInfoFir(event) {
    this.firLiberi = event.numeroFirLiberi
    this.maxFir = event.numeroFirMassimi
    this.showInfoFir = true
  }

  async viviFirEvent(event) {
    // console.log('viviFirEvent-->', event)
    if (event.name == 'onValueChanged') {
      if (event.campo.dataField === 'certificato' && this.filterID['nomeModulo'] === 'Configurazioni') {
        if (event.value !== null && event.value != undefined && event.value != "") { } else {
          this.formAnagrafica.dynamicForm.get('configurazione_rentri').get('numeroIscrizioneRentri_rentri').setValue(null)
          this.formAnagrafica.dynamicForm.get('configurazione_rentri').get('scadenza_rentri').setValue(null)
          this.formAnagrafica.dataSet['numeroIscrizioneRentri_rentri'] = null
          this.formAnagrafica.dataSet['scadenza_rentri'] = null
        }
      }
      if (event.campo.dataField === 'url_rentri' && this.filterID['nomeModulo'] === 'Configurazioni') {
        if (event.value !== null && event.value != undefined && event.value != "") {
          if (this.formAnagrafica.dataSet['password_rentri'] !== null && this.formAnagrafica.dataSet['password_rentri'] !== '') {
            this.formAnagrafica.itemOption('configurazione_rentri.certificato', 'disabled', false);
          } else {
            this.formAnagrafica.itemOption('configurazione_rentri.certificato', 'disabled', true);
          }
        } else {
          this.formAnagrafica.itemOption('configurazione_rentri.certificato', 'disabled', true);
          this.formAnagrafica.dynamicForm.get('configurazione_rentri').get('certificato').setValue(null)
          this.formAnagrafica.dataSet['certificato'] = null
        }
      }
      if (event.campo.dataField == 'password_rentri' && this.filterID['nomeModulo'] === 'Configurazioni') {
        if (event.value !== null && event.value != undefined && event.value != "") {
          if (this.formAnagrafica.dataSet['url_rentri'] !== null && this.formAnagrafica.dataSet['url_rentri'] !== '') {
            this.formAnagrafica.itemOption('configurazione_rentri.certificato', 'disabled', false);
          } else {
            this.formAnagrafica.itemOption('configurazione_rentri.certificato', 'disabled', true);
          }
        } else {
          this.formAnagrafica.itemOption('configurazione_rentri.certificato', 'disabled', true);
          this.formAnagrafica.dynamicForm.get('configurazione_rentri').get('certificato').setValue(null)
          this.formAnagrafica.dataSet['certificato'] = null
        }
      }

      if (event.campo.dataField == 'certificato' && this.filterID['nomeModulo'] === 'Configurazioni' && event.formData['password_rentri'] !== null && event.formData['password_rentri'] !== '' && event.formData['url_rentri'] !== null && event.formData['url_rentri'] !== '') {
        const formData = new FormData();
        formData.append('password', event.formData['password_rentri'])
        formData.append('certificato', event.formData['certificato'])
        if (event.formData['certificato'] !== '' && event.formData['certificato'] !== null) {
          try {
            const api = environment.BASE_API_URL.concat(this.apiset + '/GetInfoCertificato')
            const res: any = await this.httpClient.post(api, formData).toPromise();
            if (event.masterComponent.dataJson.url_rentri == res.url) {
              event.masterComponent.dataJson.numeroIscrizioneRentri_rentri = res.numeroIscrizioneOperatore
              const [day, month, year] = res.dataScadenza.split(' ')[0].split('/');
              const formattedDate = `${year}-${month}-${day}`;
              event.masterComponent.dataJson.scadenza_rentri = new Date(formattedDate);
            } else {
              alert('Indirizzo del certificato non valido per questo ambiente', 'Attenzione!')
              this.formAnagrafica.dynamicForm.get('configurazione_rentri').get('certificato').setValue(null)
              this.formAnagrafica.dataSet['certificato'] = null
            }

          } catch (error) {
            // console.log('error', event)
            this.formAnagrafica.dynamicForm.get('configurazione_rentri').get('certificato').setValue(null)
            this.formAnagrafica.dataSet['certificato'] = null
          } finally {
            this.checkRentri()
          }
        }
      }
    }
  }
  async sendCheck(type: 'isDHAttivo' | 'firmaDH' | 'rentri' | 'vivifir', params: { [key: string]: any }): Promise<boolean> {
    const queryString = new URLSearchParams(params).toString();
    const config: Record<'isDHAttivo' | 'firmaDH' | 'rentri' | 'vivifir', { method: 'GET' | 'POST'; endpoint: string; formField: string; }> = {
      firmaDH: { method: 'GET', endpoint: `DigitalHub/IsFirmaPresente?${queryString}`, formField: 'firmaDH' },
      isDHAttivo: { method: 'GET', endpoint: `DigitalHub/IsDHWasteAttivo?${queryString}`, formField: 'isDHAttivo' },
      rentri: { method: 'POST', endpoint: `rentri/AreValidCredentials`, formField: 'isRentriValido' },
      vivifir: { method: 'GET', endpoint: `Vivifir/AreValidCredentials?${queryString}`, formField: 'isVivifirValido' }
    };
    const selected = config[type];
    if (!selected) return false;
    let result: boolean;
    if (selected.method === 'GET') {
      result = await this.apiService.GetApi(selected.endpoint) as boolean;
    } else {
      result = await this.apiService.PostApi(selected.endpoint, params, 'application/x-www-form-urlencoded') as boolean;
    }
    this.formAnagrafica.formRefreshInputData(selected.formField, result ? 'si' : 'no');
    return result;
  }

  async getFirmeCount(params: { [key: string]: any }): Promise<number> {
    const queryString = new URLSearchParams(params).toString();
    let result: number;
    result = await this.apiService.GetApi(`DigitalHub/GetFirmeCount?${queryString}`) as number;
    return result
  }

  async checkDh(data: boolean | { [key: string]: any } = false): Promise<boolean> {
    const params = {
      "user": data ? data['user'] : this.formAnagrafica.dataSet['user_dh'] ? this.formAnagrafica.dataSet['user_dh'] : 'false',
      "password": data ? data['password'] : this.formAnagrafica.dataSet['password_dh'] ? this.formAnagrafica.dataSet['password_dh'] : 'false',
      "url": data ? data['url'] : this.formAnagrafica.dataSet['url_dh'] ? this.formAnagrafica.dataSet['url_dh'] : 'false',
      "company": data ? data['company'] : this.formAnagrafica.dataSet['company_dh'] ? this.formAnagrafica.dataSet['company_dh'] : 'false',
    }
    if (Object.entries(params).filter(([k, v]) => k !== 'url').every(([k, v]) => v === 'false')) {
      return false;
    }
    const isDHAttivo = await this.sendCheck('isDHAttivo', params)
    const firmaDH = await this.sendCheck('firmaDH', params)

    const nfirme = await this.getFirmeCount(params)
    this.formAnagrafica.formRefreshInputData('totFirme', nfirme)

    return (isDHAttivo && firmaDH) ? true : false
  }

  async checkRentri(data: boolean | { [key: string]: any } = false): Promise<boolean> {
    const params = new FormData()
    params.append('idSoggetto', data ? data['idSoggetto'] : this.soggettoObgj['id'])
    params.append('password', data ? data['password'] : this.formAnagrafica.dataSet['password_rentri'])
    params.append('url', data ? data['url'] : this.formAnagrafica.dataSet['url_rentri'])
    if (typeof data !== 'boolean') {
      if (typeof data['certificato'] === 'string') {
        params.append('certificato', this.utility.base64ToFileObj(data['certificato'], data['issuer'], '.p12'))
      } else {
        params.append('certificato', data['certificato'])
      }
    } else {
      if (typeof this.formAnagrafica.dataSet['certificato'] === 'string') {
        params.append('certificato', this.utility.base64ToFileObj(this.formAnagrafica.dataSet['certificato'], this.formAnagrafica.dataSet['issuer'], '.p12'))
      } else {
        params.append('certificato', this.formAnagrafica.dataSet['certificato'])
      }
    }
    return await this.sendCheck('rentri', params)
  }

  async checkVivifir(data: boolean | { [key: string]: any } = false): Promise<boolean> {
    const params = {
      "user": data ? data['user'] : this.formAnagrafica.dataSet['user_vivifir'] ? this.formAnagrafica.dataSet['user_vivifir'] : 'false',
      "password": data ? data['password'] : this.formAnagrafica.dataSet['password_vivifir'] ? this.formAnagrafica.dataSet['password_vivifir'] : 'false',
      "url": data ? data['url'] : this.formAnagrafica.dataSet['url_vivifir'] ? this.formAnagrafica.dataSet['url_vivifir'] : 'false',
      "idSoggetto": data ? data['idSoggetto'] : this.soggettoObgj['id'] ? this.soggettoObgj['id'] : 'false',
    }
    if (Object.entries(params).filter(([k, v]) => k !== 'idSoggetto' && k !== 'url').every(([k, v]) => v === 'false')) {
      return false;
    }
    return await this.sendCheck('vivifir', params)
  }
  setValidation(data: FormData, modulo: 'vivifir' | 'dh'): string {
    const chiaviEscluse = ['issuer', 'certificato', 'certificatoFirmaRemota', 'scadenzaCertificatoFirmaRemota', 'scadenza', 'numeroIscrizioneRentri', 'versione', 'idSoggetto', 'modulo', 'id', 'partitaIva']; //chiavi da escludere
    let msgHtml = ''
    if (modulo === 'vivifir') chiaviEscluse.push('company')
    if (modulo === 'vivifir') chiaviEscluse.push('url')
    if (modulo === 'dh') chiaviEscluse.push('url')
    const isVuoto = (x: any) => x === null || x === '' || x === undefined;
    const chiaviControllo = Object.entries(data).filter(([key]) => !chiaviEscluse.includes(key));
    const valoriControllo = chiaviControllo.map(([, value]) => value);
    if (valoriControllo.every(isVuoto)) {
      return '';
    }
    if (!valoriControllo.every(x => !isVuoto(x))) {
      chiaviControllo.forEach(([key, value]) => {
        if (isVuoto(value)) {
          msgHtml += `<p>${key === 'user' ? 'Client ID' : this.utility.capitalizza(key)} ${this.utility.capitalizza(modulo)} obbligatorio</p>`
        }
      });
      return msgHtml;
    }
    return '';
  }



  apriInfoFirma() {
    const titolo = `Utilizzo Firma Tecnica Rentri`
    const messagge = `
      <h5>
        AVVISO IMPORTANTE AI FINE DELLA CORRETTA TENUTA DEL REGISTRO CRONOLOGICO DI C/S
      </h5>
      <p class="text-wrap" style="max-width: 900px;text-align: left;"> La procedura di “immodificabilità/firma” del registro
        cronologico, nei termini previsti dalla
        normativa (art.
        190,
        comma 1 lettere a,b,c e d del D.lgs 152/2006), in mancanza della piattaforma DH Waste (Firma qualificata, backup
        e
        Conservazione all-in-one) utilizzerà in alternativa la <i class="text-decoration-underline">firma tecnica di dominio rilasciata dalla CA Rentri</i> così
        come
        previsto dalle istruzioni riportate al seguente
        <b>
          <a href="https://supporto.rentri.gov.it/aswsWeb/search?query=la%20firma%20rentri%20%C3%A8%20utile%20per%20firmare%20il%20registro%20cronologicio?&idProduct=RENTRI&userRole=rentriud#"
            target="_blank">link</a>
        </b>
      </p>
      <p class="text-wrap" style="max-width: 900px;text-align: left;">
        E’ da tener presente che la <i class="text-decoration-underline">firma tecnica <b>RENTRI</b> non è una firma qualificata</i> pertanto i file XML prodotti
        potrebbero
        non superare i test di verifica di validità previsti dai più comuni sistemi di firma (Vol poste italiane,
        Infocamere, Aruba, Namirial, etc. vedi <b><a
          href="https://ec.europa.eu/digital-building-blocks/DSS/webapp-demo/validation" target="_blank">link</a></b> ) e,
           in assenza di una firma qualificata, sarà necessario inviarli in conservazione nel più breve tempo
        possibile
        così come previsto dalle stesse istruzioni pubblicate sul portale R.E.N.T.Ri. e delle quali di seguito
        riportiamo
        una sintesi:
        </br>
        </br>
        <i>
          “Si aggiunge che, come previsto dalla regolamentazione tecnica in materia di tenuta e conservazione dei
          registri,
          laddove l’operatore, in base a proprie scelte di natura organizzativa, intenda archiviare il file, che
          rappresenta
          il registro elettronico, prima del trasferimento al sistema di conservazione a norma, il medesimo file dovrà
          essere
          firmato digitalmente con firma qualificata.
        </br>
          A tal proposito si rammenta che <i class="text-decoration-underline">il certificato digitale di tipo sigillo elettronico rilasciato dal RENTRI non
            può assolvere alla funzione di firma qualificata.</i>”
        </i>
        </p>
      <p class="text-wrap" style="max-width: 900px;text-align: left;">
        La procedura che segue quindi provvederà ad inoltrare i movimenti a RENTRI così come previsto dal DM 59 - art.15
        -
        comma 1, a produrre il file del registro in formato XML, a firmarlo apponendo la firma tecnica del RENTRI e ad
        archiviarlo in locale sul proprio sistema.</br>
        <b class="text-decoration-underline">RentrinCloud NON INVIERA’ IN CONSERVAZIONE IL REGISTRO XML</b>. L’obbligo di conservazione resta a cura del cliente
        che
        dovrà provvedere al versamento nel proprio sistema di conservazione a norma seguendo scrupolosamente le regole
        (Metadati, manuale di conservazione, nomina del responsabile della conservazione etc.) dettate da CAD (codice
        dell’amministrazione digitale).</br>
        Ricordiamo infine che RENTRI non è un sistema di conservazione a norma.</br>
        Per ulteriori informazioni contattare il nostro help desk o quello del partner di riferimento.
      </p>
      <blockquote class="p-0 m-0 blockquote-footer" style="max-width: 900px;text-align: left;">Lo staff di RentrinCloud.it</blockquote>`
    alert(messagge, titolo)
  }
}